import { useCallback, useState } from "react";
import { useAuth } from "../../auth/AuthContext";
import {
    applyProduitValidation,
    validationOverridesFor,
    validationUsername,
} from "./patientFormRules";

// Validations facturation / planification : le brouillon est mis à jour via
// updateSelected et un état local garde l'affichage le temps de la sauvegarde.
export default function useProduitValidations(updateSelected) {
    const { user } = useAuth();
    const [validationOverrides, setValidationOverrides] = useState({});

    const toggleValidation = useCallback((kind, produits, checked) => {
        const now = checked ? new Date().toISOString() : null;
        const username = checked ? validationUsername(user) : null;
        const change = { kind, checked, now, username };
        updateSelected(patient => ({
            ...patient,
            produits: applyProduitValidation(patient.produits || [], produits, change),
        }));
        setValidationOverrides(prev => validationOverridesFor(prev, produits, change));
    }, [updateSelected, user]);

    return { validationOverrides, toggleValidation };
}
